import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ListDepartments from "./List";
import { DEPARTMENTS, AdministrationServicePath } from "utils/constants";
import EditDepartments from "./Edit";
import CreateDepartments from "./Create";
import permissions from "app/permissions";
import ShowDepartments from "./Show";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <AccountTreeIcon />,
  name: AdministrationServicePath + DEPARTMENTS,
  title: "Катедри",
  list: <ListDepartments />,
  create: <CreateDepartments />,
  createPermission: permissions.canCreateDepartments,
  edit: <EditDepartments />,
  editPermission: permissions.canUpdateDepartments,
  show: <ShowDepartments />,
  showPermission: permissions.canPreviewDepartments,
  permission: permissions.canPreviewDepartments,
};
